import { useRouteLoaderData } from 'react-router'

import { Environment } from '~/shared/types/environment'

export const useEnvironment = (): Environment | undefined => {
  const data = useRouteLoaderData<{ env?: Environment }>('root')
  return data?.env
}